<template>
    <vxe-modal
        v-model="visible"
        title="数字员工类型变更申请"
        :width="860"
        :height="560"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <a-tabs v-model:activeKey="activeKey">
                <a-tab-pane key="1" tab="申请单">
                    <vxe-form
                        :data="formData"
                        :rules="formRules"
                        title-align="right"
                        ref="rFormChange"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="开发编号"
                            field="ProcessID"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formData.ProcessID"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="数字员工名称"
                            field="ProcessName"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formData.ProcessName"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="原数字员工类型"
                            field="oldempType"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formData.oldempType"
                                    :options="digitalTypes"
                                    disabled
                                ></vxe-select>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="新数字员工类型"
                            field="empType"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formData.empType"
                                    :options="digitalTypes"
                                    placeholder="请选择新数字员工类型"
                                    :disabled="allInputDisable"
                                ></vxe-select>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="变更原因"
                            field="changeReason"
                            span="24"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="formData.changeReason"
                                    placeholder="请输入变更原因"
                                    maxlength="1000"
                                    show-word-count
                                    :disabled="allInputDisable"
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="附件"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-paperclip' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="附件"
                            field="fAttachment"
                            span="18"
                            :item-render="{}"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formData.fAttachment"
                                    placeholder="请选择附件"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button @click="insertAttachment"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="isShowAttachmentLink"
                                href="javascript:void(0);"
                                @click="downloadFile(10)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                        </vxe-form-item>
                        <vxe-form-item
                            title="注意："
                            span="24"
                            title-width="120px"
                        >
                            <template #default>
                                <span class="notice-text">
                                    信息变更申请提交后，需要审核通过后才会更新正式上岗信息，请确认变更内容准确。
                                    <br />最大变更次数{{
                                        maxCount
                                    }}次，请谨慎操作
                                </span>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </a-tab-pane>

                <a-tab-pane key="2" tab="申请历史">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="historyData"
                        :height="330"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="操作" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-pencil-square"
                                    @click="editReject(row)"
                                    v-if="row.statusName === '已驳回'"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="statusName"
                            title="状态"
                            width="120"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.statusName === '已审核',
                                        error: row.statusName.includes('驳回'),
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.statusName }}
                                </vxe-button>
                            </template>
                        </vxe-column>

                        <vxe-column
                            field="ProcessName"
                            title="数字员工名称"
                            width="180"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="ProcessID"
                            title="开发编号"
                            width="130"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="oldempTypeName"
                            title="原数字员工类型"
                            width="150"
                            show-overflow
                        ></vxe-column
                        ><vxe-column
                            field="empTypeName"
                            title="新数字员工类型"
                            width="150"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field=""
                            title="附件"
                            width="100"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    @click="downloadFile(row)"
                                >
                                    下载
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="creationTime"
                            title="创建日期"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="UserName"
                            title="创建人"
                            width="100"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="changeReason"
                            title="变更原因"
                            min-width="200"
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </a-tab-pane>
            </a-tabs>
        </template>
        <template #footer v-if="activeKey === '1'">
            <div align="center" span="24">
                <vxe-button
                    @click="visible = false"
                    icon="fa fa-close"
                    status="danger"
                >
                    返回
                </vxe-button>

                <vxe-button
                    :loading="submitting"
                    @click="submit"
                    icon="fa fa-check"
                    status="primary"
                >
                    提交
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal
        title="审核记录"
        v-model="isShowAuditList"
        width="500"
        height="600"
    >
        <template #default>
            <div>
                <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import MyAuditLine from "../myPlug/MyAuditLine";
import {
    ref,
    reactive,
    defineExpose,
    defineEmits,
    defineProps,
    getCurrentInstance,
    onMounted,
} from "vue";
const { proxy } = getCurrentInstance();
import { VXETable } from "vxe-table";
import Qs from "qs";
const props = defineProps({
    digitalTypes: {
        type: Array,
        default: () => [
            { label: "作业型", value: "L01" },
            { label: "助手型", value: "L02" },
            { label: "专家型", value: "L03" },
        ],
    },
});
const maxCount = ref(0);
const dtAudit = ref([]);
const isShowAuditList = ref(false);
let oneAttachment = ref({}); //上传的附件
let isShowAttachmentLink = ref(false);
const emit = defineEmits(["flashPubList"]);

const activeKey = ref("1");
const submitting = ref(false);
const allInputDisable = ref(false);
const rFormChange = ref();
const historyData = ref([]);

const formData = reactive(getEmptyFormData());

const formRules = {
    empType: [{ required: true, message: "请选择新数字员工类型" }],
    changeReason: [{ required: true, message: "请输入变更原因" }],
};
const visible = ref(false);

function getEmptyFormData() {
    return {
        Id: "",
        pubId: "",

        ProcessID: "",
        ProcessName: "",
        DevelopUser: "",

        empType: "",
        oldempType: "",

        changeType: "2",
        status: "0",
        changeReason: "",
        creationTime: "",
        creator: "",
        fAttachment: null,
    };
}

const downloadFile = (row) => {
    proxy.$api.fileManageAPI
        .downloadPublishFile(
            Qs.stringify({
                publishId: row.Id,
                type: 10,
            }),
            {
                responseType: "blob",
            }
        )
        .then((res) => {
            const contentType = res.headers["content-type"] || "";

            // 如果后端返回的是 JSON，说明是错误信息
            if (contentType.includes("application/json")) {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const result = JSON.parse(reader.result);

                        VXETable.modal.alert({
                            content:
                                result.Message || result.message || "下载失败",
                            status: "error",
                        });
                    } catch (e) {
                        VXETable.modal.alert({
                            content: "下载失败",
                            status: "error",
                        });
                    }
                };

                reader.readAsText(res.data);
                return;
            }

            let fileName = "下载文件";

            const disposition =
                res.headers["content-disposition"] ||
                res.headers["Content-Disposition"];

            if (disposition) {
                const utf8Match = disposition.match(
                    /filename\*=UTF-8''([^;]+)/i
                );
                const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (normalMatch && normalMatch[1]) {
                    fileName = decodeURIComponent(normalMatch[1]);
                }
            }

            const blob = new Blob([res.data], {
                type: contentType || "application/octet-stream",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.log(error);

            VXETable.modal.alert({
                content: "文件下载失败",
                status: "error",
            });
        });
};
function resetFormData() {
    const emptyData = getEmptyFormData();

    Object.keys(emptyData).forEach((key) => {
        formData[key] = emptyData[key];
    });
}
function showAuditList(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [row.Id, "1"], //
    };
    proxy.$api.requireManageAPI
        .getAuditRecordList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtAudit.value = res.data.Data;
            isShowAuditList.value = true;
        })
        .catch((error) => {
            console.log(error);
        });
}
const insertAttachment = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formData.fAttachment = file.name;
        oneAttachment.value = file;
    });
};
function editReject(row) {
    if (!row) {
        return;
    }

    formData.Id = row.Id ?? "";
    formData.pubId = row.pubId ?? "";
    formData.empType = row.empType ?? "";
    formData.oldempType = row.oldempType ?? "";
    formData.status = "1";
    formData.creator = row.creator ?? "";
    formData.changeReason = row.changeReason ?? "";
    formData.changeType = row.changeType ?? "";

    // 如果你有弹窗，可以在这里打开
    activeKey.value = "1";
}
function init(row) {
    resetFormData();

    activeKey.value = "1";
    submitting.value = false;
    allInputDisable.value = false;
    formData.Id = proxy.$utils.guid();
    formData.pubId = row.Id;
    formData.ProcessID = row.ProcessID || "";
    formData.ProcessName = row.ProcessName || "";
    formData.empType = row.empType ?? "";
    formData.oldempType = row.empType ?? "";
    formData.changeType = "2"; //员工类型变更
    formData.status = "1";
    formData.changeReason = "";
    formData.creator = proxy.$store.state.userID;
    setHistory(row);
    visible.value = true;
}

function setHistory(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 50,
        searchKey: [row.Id, "2"],
    };
    proxy.$api.newPublishManageAPI
        .getPublishInfoChange(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            // console.log(res.data.Data);
            historyData.value = Array.isArray(res.data.Data.dataTable)
                ? res.data.Data.dataTable
                : [];
        })
        .catch((error) => {
            console.log(error);
        });
}
const getModel = () => {
    const data = new FormData();
    data.append("fileAttachment", oneAttachment.value);
    data.append("Id", formData.Id);
    data.append("pubId", formData.pubId);
    data.append("fAttachment", formData.fAttachment);
    data.append("empType", formData.empType);
    data.append("oldempType", formData.oldempType);
    data.append("status", formData.status);
    data.append("creator", formData.creator);
    data.append("changeReason", formData.changeReason);
    data.append("changeType", formData.changeType);
    return data;
};
async function submit() {
    if (!rFormChange.value) {
        return;
    }

    const errMap = await rFormChange.value.validate().catch((errMap) => errMap);

    if (errMap) {
        return;
    }

    if (String(formData.empType ?? "") === String(formData.oldempType ?? "")) {
        VXETable.modal.message({
            content: "新数字员工类型不能与原类型相同",
            status: "warning",
        });
        return;
    }
    if (formData.fAttachment === "" || formData.fAttachment == null) {
        VXETable.modal.message({
            content: "请上传附件",
            status: "warning",
        });
        return;
    }
    const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

    if (type === "confirm") {
        submitting.value = true;
        const data = getModel();
        proxy.$api.newPublishManageAPI
            .addPublishInfoChange(data)
            .then((res) => {
                if (res.data.Success == false) {
                    submitting.value = false;
                    VXETable.modal.alert({
                        content: res.data.Message,
                        status: "error",
                    });
                    submitting.value = false;
                    return;
                }
                VXETable.modal.message({
                    content: "提交成功",
                    status: "success",
                });
                submitting.value = false;
                emit("flashPubList");
                addAuditRecord("0", "1"); //写审核日志
                visible.value = false;
            })
            .catch((error) => {
                submitting.value = false;
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    }
}
const addAuditRecord = (status, type) => {
    let auditBuId = "";
    let auditOpinion = "";
    switch (type) {
        case "1":
            auditBuId = formData.Id;
            auditOpinion = "";
            break;
    }
    //写审核日志
    const params = {
        auditBuId: auditBuId,
        auditMan: proxy.$store.state.userName,
        auditManUid: proxy.$store.state.userID,
        auditStatus: status, //0发起 1 通过 2 驳回
        auditOpinion: auditOpinion,
        auditNode: "审核发起",
    };
    proxy.$api.requireManageAPI
        .addAuditRecord(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

function getMaxChangeCount() {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [],
    };
    proxy.$api.newPublishManageAPI
        .getPublishChangeCount(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            maxCount.value = res.data.Data.maxCount;
        })
        .catch((error) => {
            console.log(error);
        });
}

onMounted(() => {
    getMaxChangeCount();
});
defineExpose({
    init,
});
</script>

<style scoped>
.apply-page {
    padding: 16px;
    background: #fff;
}

.notice-text {
    color: red;
}

.active {
    color: green;
}

.error {
    color: red;
}
</style>
